const numericPattern = /^\d(\.\d{1,2})?$/;

const stripZeroWidth = (s: string) => s.replace(/[\u200B-\u200D\uFEFF]/g, '');

export const parseColNumber = (
  n: string,
  defaultValue: number | string,
): number | string => {
  const clean = stripZeroWidth(n);
  if (clean === 'None') return 0;
  const match = numericPattern.exec(clean);
  return match ? Number(match[0]) : defaultValue;
};

export const parseMaxWidth = (
  v: string | null | undefined,
): string | undefined => {
  if (!v || stripZeroWidth(v) === 'full') {
    return undefined;
  }

  return v;
};
import type { SwiperOptions } from 'swiper/types';

function isNumeric(x: number | string) {
  return (typeof x === 'number' || typeof x === 'string') && !isNaN(Number(x));
}

export const calcSwiperSlideMaxWidth = (option: SwiperOptions) => {
  const spaceBetween = option.spaceBetween ?? 0;
  const slidesPerView = option.slidesPerView ?? 'auto';
  if (!isNumeric(slidesPerView)) {
    return '';
  }

  // Convert to Number to ensure proper calculation with decimal values
  const slidesPerViewNum = Number(slidesPerView);

  // Handle the case where slidesPerView might be a decimal number
  const multiplier = Math.max(0, slidesPerViewNum - 1);

  const totalSpace = isNumeric(spaceBetween)
    ? `${Number(spaceBetween) * multiplier}px`
    : `${spaceBetween} * ${multiplier}`;

  const width = `calc((100% - ${totalSpace}) / ${slidesPerViewNum})`;

  return `max-width: ${width};`;
};

/**
 * calc swiperSlideMaxWidth
 * not support radio for now
 */
export const calcSwiperSlideMaxWidthByBreakpoints = (
  breakpoints: SwiperOptions['breakpoints'],
) => {
  return calcByBreakpointsGenerate(breakpoints, calcSwiperSlideMaxWidth);
};

const calcByBreakpointsGenerate = (
  breakpoints: SwiperOptions['breakpoints'],
  calcMethod: (option: SwiperOptions) => string,
) => {
  let result = '';
  for (const key in breakpoints) {
    const option = breakpoints[key];

    const value = calcMethod(option);
    if (!value) {
      continue;
    }
    const mediaQuery = `${'@media only screen and '}(min-width: ${key}px)`;
    result += `
        ${mediaQuery} {
            ${value}
        }
    `;
  }
  return result;
};

export const calcSwiperSlideSpaceBetween = (option: SwiperOptions) => {
  const spaceBetween = option.spaceBetween ?? 0;
  let result;
  if (isNumeric(spaceBetween)) {
    result = `${Number(spaceBetween)}px`;
  } else {
    result = `${spaceBetween}`;
  }
  return `margin-right: ${result};`;
};

export const calcSwiperSlideBetweenByBreakpoints = (
  breakpoints: SwiperOptions['breakpoints'],
) => {
  return calcByBreakpointsGenerate(breakpoints, calcSwiperSlideSpaceBetween);
};
